var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-asnwers"},[_c('div',{staticClass:"columns is-gapless is-vh"},[_c('div',{staticClass:"column is-2 has-background-dark"},[_c('Sidebar')],1),_c('div',{staticClass:"column"},[_c('div',{staticClass:"section"},[_c('h1',{staticClass:"title"},[_vm._v("Answers Overview")]),_c('hr'),_c('AnswersOverview')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }